module.exports = __webpack_public_path__ + "img/Close.bd986621.svg";